import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Form, Row, Input, Col, Select } from 'antd';
import FormModal from './FormModal'
import { PAGE_SIZE_DEFAULT } from '../../../constants/appConstant';
@inject('approvePermissionStore')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: false,
  }
  formRef = React.createRef();
  componentDidMount() {
    this.formRef.current.setFieldsValue({
      status: '0'
    })
  }
  handleSearch=()=>{
    const { approvePermissionStore } = this.props
      this.formRef.current.validateFields().then(fieldsValue => {
        approvePermissionStore.onSearchApproveAction({
          pageNum: 0,
          pageSize: 0,
          status: fieldsValue.status,
          userName: fieldsValue.userName
        },1,PAGE_SIZE_DEFAULT)
      }).catch(err => {})
  }
  handleCreate=()=>{
    this.setState({
      addModalVisible: true
    })
  }
  handleCancel=()=>{
    this.setState({
      addModalVisible: false
    })
  }
  render() {
    const formItemLayout = {
      labelCol: { span: 7},
      wrapperCol: { span: 17 },
    }
    return (
      <>
        <Row>
          <Col span={18}>
            <Form ref={this.formRef} labelCol={{ span: 8 }}>
              <Row><Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8} span={8}>
                <Form.Item name='userName' label='User Name' {...formItemLayout}
                           rules={[{ message: 'Please enter User Name without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) }]}>
                  <Input maxLength={100} placeholder="Please enter ..." allowClear />
                </Form.Item>
              </Col>
                <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8} span={8}>
                  <Form.Item name='status' label='Status' {...formItemLayout}>
                    <Select placeholder="Please enter ..." allowClear>
                      <Select.Option key='0' value='0'>Processing</Select.Option>
                      <Select.Option key='1' value='1'>Approved</Select.Option>
                      <Select.Option key='2' value='2'>Rejected</Select.Option>
                      <Select.Option key='3' value='3'>Invalid</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
          <Col span={6} style={{textAlign: 'right'}}>
            <Button onClick={this.handleSearch} type='primary'>Search</Button>
          </Col>
        </Row>
        {this.state.addModalVisible?<FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
        />:null}
      </>
    );
  }
}

export default SearchForm;
